module.exports = __webpack_public_path__ + "img/two-dimensional_1.5ea9fd86.png";